function setHeaderHomePagePosition() {
    const stickyHeader = $('.js-header-home-page-sticky');
    const heroSection = $('.js-hero-section');
    const heroHeight = heroSection.height();

    let wST = $(window).scrollTop();

    if (wST > heroHeight) {
        stickyHeader.addClass('is-sticky');
    } else {
        stickyHeader.removeClass('is-sticky');
    }

    lastScrollTopPos = wST;
}

runIfElementExist(setHeaderHomePagePosition, '.js-header-home-page-sticky');

$(window).on('scroll', function () {
    setHeaderHomePagePosition();
});
